var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 24.5847C26.6285 24.5847 32.2223 25.603 32.2223 29.5319C32.2223 33.4623 26.5918 34.4446 20.0001 34.4446C13.3731 34.4446 7.77783 33.4262 7.77783 29.4973C7.77783 25.5669 13.4083 24.5847 20.0001 24.5847ZM20.0001 5.55566C24.4903 5.55566 28.0881 8.95592 28.0881 13.1983C28.0881 17.4407 24.4903 20.8424 20.0001 20.8424C15.5113 20.8424 11.912 17.4407 11.912 13.1983C11.912 8.95592 15.5113 5.55566 20.0001 5.55566Z",
    fill: "#007A6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.3b806df2e7621338d7852d568cf0e476.svg";
export { ForwardRef as ReactComponent };